module.exports = __webpack_public_path__ + "img/黃金萬兩_四方連續_線稿_black.bc0b1417.png";